<template lang="pug">
  .h-100
    button.video-controller__button(
      :class="toggleIcon",
      type="button",
      :data-index="dataIndex",
      @click="toggleMicrophone",
      @mouseenter="onMouseEnter"
    )
      img.video-controller__icon(src="/static/img/app/btn-microphone.svg")
    span.text-nowrap.video-controller__tooltip
      | {{ tooltip }}
</template>

<script>
export default {
  name: 'MicrophoneButton',
  props: [
    'onMouseEnter',
    'onMouseLeave',
    'dataIndex'
  ],
  data () {
    return {
      flag: true,
      toggleText: {
        true: 'マイクOFF',
        false: 'マイクON'
      }
    }
  },
  computed: {
    toggleIcon () {
      return this.flag ? '' : 'is-off'
    },
    tooltip () {
      return this.toggleText[String(this.flag)]
    },
    localUser () {
      return this.$store.getters.localUser
    }
  },
  watch: {
    localUser () {
      // 他のユーザーが、自分のストリームの音声のON/OFFを押下した場合
      if (this.flag !== this.localUser?.micFlag) {
        this.flag = !this.flag
      }
    }
  },
  methods: {
    toggleMicrophone () {
      this.flag = !this.flag

      const payload = {
        type: 'users',
        peerId: this.$store.state.peerId,
        data: {
          micFlag: this.flag
        }
      }

      // マイクフラグを共有
      this.$store.state.room.send(payload)
      this.$store.dispatch('updateUsers', { payload })
    }
  }
}
</script>
